import script from "./JoinDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./JoinDialog.vue?vue&type=script&lang=ts&setup=true"

import "./JoinDialog.vue?vue&type=style&index=0&id=1413a822&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1413a822"]])

export default __exports__